import { render, staticRenderFns } from "./ShortListCommentModal.vue?vue&type=template&id=0ed8ccd2"
import script from "./ShortListCommentModal.vue?vue&type=script&lang=js"
export * from "./ShortListCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports